import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
)
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
)
const CheckIcon = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 'auto' }}>
        <polyline points="20 6 9 17 4 12" />
    </svg>
)

/**
 * "Filters" button in the same style as the Jobs page, opening a small status
 * menu. `value` is the active status ('' = all); `options` are { value, label }.
 */
export const StatusFilter = ({ value, options, onChange }) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)

    const pick = (next) => {
        setOpen(false)
        onChange(next)
    }

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <button type="button" className={`filter-toggle${open ? ' on' : ''}`} onClick={() => setOpen(o => !o)} aria-expanded={open} aria-haspopup="menu">
                <FilterIcon /> {t('platform.filters.title')}
                {value && <span className="cnt">1</span>}
                <ChevIcon />
            </button>
            {open && (
                <>
                    <div style={{ position: 'fixed', inset: 0, zIndex: 150 }} onClick={() => setOpen(false)} aria-hidden="true" />
                    <div className="p-action-dropdown" role="menu" style={{ left: 0, right: 'auto', marginTop: 6 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#9CA3B0', textTransform: 'uppercase', letterSpacing: '.04em', padding: '6px 10px 4px' }}>
                            {t('platform.filters.status')}
                        </div>
                        {[{ value: '', label: t('platform.filters.all') }, ...options].map(o => {
                            const on = value === o.value
                            return (
                                <button key={o.value || 'all'} type="button" role="menuitemradio" aria-checked={on}
                                    className="p-action-dropdown-item" onClick={() => pick(o.value)}
                                    style={on ? { color: 'var(--brand)', fontWeight: 700 } : undefined}>
                                    {o.label}
                                    {on && <CheckIcon />}
                                </button>
                            )
                        })}
                    </div>
                </>
            )}
        </div>
    )
}

/**
 * Context banner for an active filter — the same look as the Jobs page
 * "Showing 4 unassigned jobs — …" strip, with a Clear button.
 */
export const FilterBanner = ({ highlight, hint, onClear }) => {
    const { t } = useTranslation()

    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', marginBottom: 14,
            background: 'var(--brand-50)', border: '1px solid var(--brand-100)', borderRadius: 'var(--r-sm, 10px)'
        }}>
            <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="var(--brand)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}>
                {t('platform.filters.showing')} <span style={{ color: 'var(--brand)' }}>{highlight}</span> — {hint}
            </span>
            <button
                type="button"
                onClick={onClear}
                style={{
                    marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 5, flexShrink: 0,
                    background: '#fff', border: '1px solid var(--brand-100)', borderRadius: 8,
                    color: 'var(--brand)', fontWeight: 700, fontSize: 12.5, padding: '5px 10px', cursor: 'pointer'
                }}
            >
                {t('platform.filters.clear')}
                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
        </div>
    )
}
